export default {
    linkList: {
        "operationPolicy": "Политика пользования",
        "communityPolicy": "Правила сообщества",
        "youthProtectionPolicy": "Политика защиты несовершеннолетних",
        "declarationOfSafety": "Декларация о безопасности",
        "cookiePolicy": "Политика использования Cookies",
        "customerSupport": "Служба поддержки",
        "guaranteeOfRights": "Гарантия прав субъектов данных",
        "privacyPolicy": "Политика конфиденциальности",
        "termsOfService": "Пользовательское соглашение",
        "companyLink": "Описание компании",
        "doNotSell": "Do Not Sell My Personal Information",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
        "reportRightsInfringement": "권리침해신고",
    },
    footerWords: {
        "gameRelatedLaw": "Дополнительные примечания в связи с законом о регулировании игр",
        "brandInformation": "Информация о названии компании",
        "copyright": "Авторское право",
        "channelingInfo": "NCSOFT Corporation является посредником в предоставлении игр с восможностью использования единого игрового ID в plaync, но не является заинтересованным лицом в осуществлении их продаж.<br>Все обязательства и ответственность, связанные с предоставлением данных игр, возлагается на официальных представителей по прадаже. За все проблемы, возникающие в данных играх, NCSOFT Corporation ответственности не несёт."
    },
    infoCS: {
        "businessInformation": "Проверка данных предпринимателя",
        "infoAddress": "Президент компании NCSOFT Corporation - Kim Taek Jin Номер удостоверения предпринимателя: 144-85-04244 Заявление на ведение онлайн-продаж: 2013-Gyeonggi Seongnam-1268",
        "mobile": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1566-7004. Факс: +82-2-2186-3499",
        "pc": "",
        "other": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1600-0020 (игры для ПК), +82-1566-7004 (мобильные игры). Факс: +82-2-2186-3550 (игры для ПК), +82-2-2186-3499 (мобильные игры).",
        "none": '',
        "infoEmail": "Электронная почта",

        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(игры для ПК)/MobileCS@ncsoft.com/(мобильные игры)",
        "infoEmail-none": "",
    },
    infoJP: {
        "jpReleaseDayValue_LW": "4 ноября 2021",
        "jpReleaseDay": "Дата выпуска",
        "jpDevelopedBy": "Отдел разработок/Отдел управления",
        "jpOs": "Совместимая ОС",
        "jpPriceValue": "Бесплатно (Поддерживаются покупки в приложении)",
        "jpPrice": "Стоимость",
        "jpGenre": "Жанр",
        "jpTitle": "Название",
    },
    "country": {
        "HK": "Гонконг",
        "PH": "Филиппины",
        "TH": "Таиланд",
        "QA": "Катар",
        "JP": "Япония",
        "ID": "Индонезия",
        "AE": "Арабские Эмираты",
        "SG": "Сингапур",
        "SA": "Саудовская Аравия",
        "MY": "Малайзия",
        "RU": "Россия",
        "TW": "Тайвань",
        "KR": "Республика Корея",
        "UA": "Украина",
        "BY": "Белоруссия",
        "LT": "Литва",
        "PL": "Польша",
        "GR": "Греция",
        "IL": "Израиль",
        "KW": "Кувейт",
        "AT": "Австрия",
        "US": "США",
        "CA": "Канада",
        "DE": "Германия",
        "GB": "Великобритания",
        "FR": "Франция",
        "BR": "Бразилия",
        "IT": "Италия",
        "ES": "Испания",
        "CL": "Чили",
        "NO": "Норвегия",
        "SE": "Швеция",
        "IE": "Ирландия",
        "PT": "Португалия",
        "FI": "Финляндия",
        "DK": "Дания",
        "CH": "Швейцария",
        "AR": "Аргентина",
        "PE": "Перу",
        "MX": "Мексика",
        "KZ": "Казахстан",
        "UZ": "Узбекистан",
        "AZ": "Азербайджан",
        "GE": "Грузия",
        "MD": "Молдова",
        "AM": "Армения",
        "MO": "Макао",
        "IN": "Индия",
        "PK": "Пакистан",
        "NL": "Нидерланды",
        "RO": "Румыния",
        "AU": "Австралия",
        "TR": "Турция",
        "EC": "Эквадор",
        "CO": "Колумбия",
        "ZA": "Южная Африка",
        "EG": "Египет",
        "NC": "Global"
    }
};
